import React from 'react';
import './Contact.css';

export default function Contact() {
    
    const openGoogleMaps = () => {
        window.open("https://www.google.com/maps/place/OptiZak/@45.6540604,25.605441,15z/data=!4m7!3m6!1s0x40b35bedbc4c8f73:0x369173d587233478!8m2!3d45.6540604!4d25.605441!9m1!1b1", "_blank");
    };

   
    const sendEmail = () => {
        window.location.href = "mailto:optizak@gmail.com";
    };

    
   return (
        <div>
            <div>
                <h1>CONTACT OPTIZAK</h1>
            </div>
            <div className="container text-center locati">
                <div className="row align-items-center">
                    <div className="col">
                        <iframe 
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2788.838724348313!2d25.605441000000003!3d45.6540604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b35bedbc4c8f73%3A0x369173d587233478!2sOptiZak!5e0!3m2!1sro!2sro!4v1720637543349!5m2!1sro!2sro" 
                            width="600" 
                            height="450" 
                            style={{ border: "0" }} 
                            allowFullScreen="" 
                            loading="lazy" 
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Harta locației OptiZak"
                        ></iframe>
                        <button onClick={openGoogleMaps} className="btn btn-primary mt-3">
                            Deschide în Google Maps
                        </button>
                    </div>
                    <div className="col">
                        <h5 className="card-title">
                            Persoana de Contact: <br /> Zaharia Camelia - Administrator
                        </h5>
                        <p>Strada 13 Decembrie nr. 24, Brașov</p>
                        <p>+40 727 700 008</p>
                        <p><a href="mailto:optizak@gmail.com">optizak@gmail.com</a></p>
                        <button onClick={sendEmail} className="btn btn-success mt-3">
                            Trimite Email
                        </button>
                    </div>
                </div>
            </div>

            <div className="container text-center">
                <div className="row align-items-center">
                    <div className="col">
                        <div>
                            Magazinul Optica Tehnico Medicale te așteaptă în fiecare zi, de Luni până Sâmbătă, în centrul istoric al Brașovului, pe Strada Republicii, nr. 55, cu produse de calitate, consultații realizate de medici de renume, asistență profesională și prețuri avantajoase. Îți punem la dispoziție o gamă largă de produse pe stoc, precum și posibilitatea de a comanda unele specifice, direct din catalogul furnizorilor. Vei găsi la noi toate tipurile de lentile pentru ochelari – monofocale, bifocale, progresive, din sticlă organică sau minerală, policarbonate, fotocromatice sau cu polarizare, ochelari de soare cu protecție UV de la diverși producători de renume, lentile de contact, rame pentru toate gusturile și stilurile, accesorii, precum și o gamă variată de produse tehnico-medicale.
                        </div>
                        
                    </div>
                    <div className="col">
                        <div>
                            <img src="./imagini/locatie 1.webp" alt="Locația OptiZak din centrul istoric Brașov" style={{ maxWidth: "100%" }} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
